import React, { Component } from 'react';
import Lightbox from 'react-image-lightbox';
// see https://reactjs.org/docs/lists-and-keys.html
// and https://reactjs.org/docs/composition-vs-inheritance.html

function Labels(props) {
  return props.labels.map((label, j) => {
    return (
      <label key={j}>{label}</label>
    );
  })
}

function PortfolioItems(props) {
  return props.items.map((item, i) => {
    const { name, icon, filters, labels } = item;
    return (
      <div key={i} className={"col-sm-4 col-xs-6 mix " + filters.join(' ')}>
        <div className="portfolio-col">
          <img src={icon} alt="" />
          <div className="hover" onClick={() => props.handler(i)}>
            {/* https://reactjs.org/docs/faq-functions.html */}
            <h4>{name}</h4>
            <Labels labels={labels} />
            <h5>click to view screens</h5>
          </div>
        </div>
      </div>
    );
  })
}

export default class Filter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      photoIndex: 0,
      images: [],
      isOpen: false
    };

    // binding is necessary to make `this` work in the callback
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    let container = document.querySelector('.portfolio-filter');
    /*eslint-disable */
    let mixer = mixitup(container);
    /*eslint-enable */
  }

  handleClick(index) {
    const item_images = this.props.opts.items[index].images
    this.setState({ images: item_images, isOpen: true, photoIndex: 0 });
    //console.log(`clicked ${index}, isOpen: ${this.state.isOpen ? 'YES' : 'NO'}`);
  }

  render() {
    const { photoIndex, images, isOpen } = this.state;

    return (
      <div className="portfolio-filter">
        <div className="row">
          <PortfolioItems items={this.props.opts.items} handler={this.handleClick} />
        </div>

        {isOpen && (
          <Lightbox
            mainSrc={images[photoIndex]}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={() => this.setState({ isOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + images.length - 1) % images.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % images.length,
              })
            }
          />
        )}
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/Filter.js